import { getIdmeGroupInfo } from './get-id-me-group-info'

interface CouponInfo {
  message: string
  discountLabel: string
  isIdme: boolean
}

export const getCouponInfo = (coupon: string): CouponInfo => {
  const { groupLabel, isIdme } = getIdmeGroupInfo(coupon)

  if (isIdme && groupLabel) {
    return {
      message: `${groupLabel} discount applied successfully`,
      discountLabel: `${groupLabel} Discount`,
      isIdme,
    }
  }

  return {
    message: 'Promo code applied successfully',
    discountLabel: coupon,
    isIdme,
  }
}
